// Mock data for Mahasarathi website

export const features = [
  {
    id: 1,
    title: "Live ETA",
    description: "Real-time tracking and arrival predictions across all transport modes",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Plan Journey",
    description: "Smart route planning with multi-modal options for optimal travel",
    icon: "Map"
  },
  {
    id: 3,
    title: "Book Tickets",
    description: "Seamless booking for buses, trains, flights, and cabs in one place",
    icon: "Ticket"
  },
  {
    id: 4,
    title: "Unified Payment",
    description: "Pay once for all services with secure, integrated payment system",
    icon: "CreditCard"
  },
  {
    id: 5,
    title: "Track & Arrive",
    description: "Stay updated with live notifications and GPS-based journey tracking",
    icon: "Navigation"
  },
  {
    id: 6,
    title: "Smart Suggestions",
    description: "AI-powered recommendations for faster and cost-effective routes",
    icon: "Lightbulb"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Save Time",
    description: "Compare routes instantly and choose the fastest option for your journey",
    icon: "Timer"
  },
  {
    id: 2,
    title: "Save Money",
    description: "Find the most economical travel combinations across all modes",
    icon: "IndianRupee"
  },
  {
    id: 3,
    title: "Hassle-Free Travel",
    description: "One app for all your commute needs - no more juggling multiple platforms",
    icon: "Smile"
  },
  {
    id: 4,
    title: "Eco-Friendly Options",
    description: "Choose sustainable transport modes and reduce your carbon footprint",
    icon: "Leaf"
  }
];

export const partners = [
  { id: 1, name: "Indian Railways", category: "Train" },
  { id: 2, name: "State RTCs", category: "Bus" },
  { id: 3, name: "Metro Rail", category: "Metro" },
  { id: 4, name: "ONDC", category: "Integration" },
  { id: 5, name: " ", category: "Cab" },
  // { id: 6, name: "Uber", category: "Cab" },
  { id: 6, name: "Domestic Flights", category: "Flight" },
  // { id: 7, name: "RedBus", category: "Bus" },
  { id: 7, name: "City Cooperatives", category: "Auto" },
  { id: 8, name: "E-Autos", category: "Auto" }
];

export const pricingPlans = [
  // {
  //   id: 1,
  //   name: "Free",
  //   price: 0,
  //   period: "month",
  //   features: [
  //     "Basic route planning",
  //     "Live ETA for public transport",
  //     "Limited booking options",
  //     "Standard support"
  //   ],
  //   recommended: false
  // },
  // {
  //   id: 2,
  //   name: "Pro",
  //   price: 199,
  //   period: "month",
  //   features: [
  //     "Advanced route optimization",
  //     "Unlimited bookings across all modes",
  //     "Priority booking",
  //     "Real-time alerts & notifications",
  //     "Multi-city planning",
  //     "24/7 priority support"
  //   ],
  //   recommended: true
  // },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "month",
    features: [
      "All Pro features",
      "Corporate travel management",
      "Team collaboration tools",
      "Custom integrations",
      "Dedicated account manager",
      "Advanced analytics & reporting"
    ],
    recommended: false
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Multi-Modal Transport in India",
    excerpt: "Exploring how integrated mobility platforms are transforming urban commute across Indian cities.",
    author: "Rajesh Kumar",
    date: "2025-01-15",
    category: "Technology",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=800"
  },
  {
    id: 2,
    title: "10 Tips for Eco-Friendly Commuting",
    excerpt: "Simple ways to reduce your carbon footprint while traveling efficiently in the city.",
    author: "Priya Sharma",
    date: "2025-01-10",
    category: "Sustainability",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800"
  },
  {
    id: 3,
    title: "How Real-Time ETA Saves Your Day",
    excerpt: "Understanding the technology behind accurate arrival predictions and why it matters.",
    author: "Amit Patel",
    date: "2025-01-05",
    category: "Features",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=800"
  },
  {
    id: 4,
    title: "Mahasarathi Integration Guide for Developers",
    excerpt: "Learn how to integrate Mahasarathi APIs into your applications for seamless mobility solutions.",
    author: "Deepak Singh",
    date: "2024-12-28",
    category: "Developer",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800"
  }
];

// export const testimonials = [
//   {
//     id: 1,
//     name: "Sneha Reddy",
//     role: "Software Engineer",
//     content: "Mahasarathi has made my daily commute so much easier! I can now compare and book all my travel options in one place.",
//     rating: 5
//   },
//   {
//     id: 2,
//     name: "Vikram Mehta",
//     role: "Business Consultant",
//     content: "The real-time tracking feature is a game-changer. I never miss meetings anymore thanks to accurate ETAs.",
//     rating: 5
//   },
//   {
//     id: 3,
//     name: "Anjali Desai",
//     role: "Student",
//     content: "As a student, the cost comparison feature helps me save money on daily travel. Highly recommended!",
//     rating: 5
//   }
// ];
